import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ColDef, ColGroupDef, ICellRendererParams } from 'ag-grid-community';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { PrDetailsComponent } from 'src/app/modules/shared/containers/modals/pr-details/pr-details.component';
import { IAPIResponse, IBuyerRC, IPurchaseRequest } from 'src/app/modules/shared/models';
import { DatePipe } from '@angular/common'
import { RcImageDisplayComponent } from '../../components/rc-image-display/rc-image-display.component';
import { EncryptionOptions } from 'jspdf';
import { EncryptionService } from 'src/app/modules/dashboard/services/encryption.service';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateInvalidateRequestService {

  public bsModalRef!: BsModalRef;
  

  constructor(private http: HttpClient,
    private _modalService: BsModalService,
    private _encryptionService: EncryptionService,
    private _authService: AuthService,
    private dp: DatePipe) { }

  public getColumnDefs(materialMasterList: any): (ColDef | ColGroupDef)[] {
    const currentRole = this._authService.getUserRole();
    const coldefs = [
          { headerName: 'Item #/ Serial #', field: 'line_item_number', resizable: true, filter: true, columnGroupShow: 'open',checkboxSelection: (data: any) => {
            return data.data.line_item_status =='APPROVED' ? true : false;
          }, headerCheckboxSelection:false, },
          { headerName: 'Line Item Status', field: 'line_item_status', resizable: true, filter: true, columnGroupShow: 'closed'},
          { headerName: 'Item Category', field: 'item_category', resizable: true, filter: true, columnGroupShow: 'closed'},
          {
            headerName: 'Expected Delivery Date', field: 'delivery_date', cellRenderer: (data: any) => {
              return data.value ? (new Date(data.value)).toLocaleDateString() : '';
            }
          },
          { headerName: 'Material Code/Service Code', field: 'material_code', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'HSN/SAC', field: 'hsn_sac'},
          { headerName: 'Item Description', field: 'item_desc', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Specs/ short Description', field: 'short_text', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Material Group', field: 'matl_group', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Quantity', field: 'quantity', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Short Text', field: 'short_text', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Ordering Unit', field: 'ordering_unit', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Unit Price', field: 'price', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Currency', field: 'currency', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Warranty', field: 'warranties', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'PO Text', field: 'po_text', resizable: true, filter: true, columnGroupShow: 'closed' },
          {
            headerName: 'Expected delivery date', field: 'delivery_date', resizable: true, filter: true, columnGroupShow: 'closed', cellRenderer: (data: any) => {
              return data.value ? (new Date(data.value)).toLocaleDateString() : '';
            }
          },
      currentRole !== 'FACTORY_PROCUREMENT'?
      {
        groupId: 'prActionGroup',
        headerName: 'Actions',
        children: [
          // { headerName: 'Price Status', pinned: 'right', field: 'material_master.price_status', resizable: true, filter: true },
          // { headerName: 'Supplier market assessment status', field: 'material_master.supplier_market_assement_status', resizable: true, filter: true, pinned: 'right', },
          /* {
            headerName: 'Actions', pinned: 'right', resizable: true, filter: true,
            cellRenderer: 'AgGridActionsRendererComponent',
            cellRendererParams: [
              { name: "Run PPC", icon: "" }],
            cellEditor: 'AgGridActionsWrapperComponent',
            cellEditorPopup: true,
            singleClickEdit: true,
            editable: true,
          }, */
          materialMasterList[0]?.material_master?.line_item_status !== 'RC_PASSED'?{ headerName: 'Actions', field: 'action', pinned: 'right', cellRendererSelector: (params: ICellRendererParams) => {
              return  {
                component: 'PriceValidationActionComponent'
              }
          }, meta: { materialMasterList: materialMasterList }
         }:''
        ],
      }:{}
    ];
    return coldefs;
  }

  public getMaterialMasterData(prId: any): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    const id = parseInt(prId)
    return this.http.post<IAPIResponse<Array<IPurchaseRequest>>>(`${API_URL.GET_PR_BY_ID}`, { prId: [id] });
  }
  
  public createRCAutoPO(body: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<IAPIResponse<Array<any>>>(`${API_URL.PO_CREATE.CREATE_RC_PO}`, body);
  }

  public getRcViewColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      { headerName: 'Image', field: 'image_base64', checkboxSelection: true, headerCheckboxSelection: true,cellRendererFramework: RcImageDisplayComponent},
      { headerName: 'Item Category', field: 'item_category', resizable: true, filter: true},
      { headerName: 'Material Code/Service Code', field: 'material_code', resizable: true, filter: true},
      { headerName: 'HSN/SAC', field: 'material_master.hsn_sac'},
      { headerName: 'Supplier AID', field: 'supplier_aid', resizable: true, filter: true},
      { headerName: 'Short Description', field: 'discription_short', resizable: true, filter: true},
      { headerName: 'Long Description', field: 'discription_long', resizable: true, filter: true},
      { headerName: 'Manufacturer name', field: 'manufacturer_name', resizable: true, filter: true },
      { headerName: 'Manufacturer AID', field: 'manufacturer_aid', resizable: true, filter: true },
      { headerName: 'Price Quantity', field: 'price_quantity', resizable: true, filter: true },
      { headerName: 'Order Unit', field: 'order_unit', resizable: true, filter: true },
      { headerName: 'TAX', field: 'tax', resizable: true, filter: true },
      { headerName: 'LOWER_BOUND1', field: 'lower_bound1', resizable: true, filter: true },
      { headerName: 'Price Amount', field: 'price_amount1', resizable: true, filter: true },
      { headerName: 'Currency', field: 'currency', resizable: true, filter: true },
      { headerName: 'Quantity Min', field: 'quantity_min', resizable: true, filter: true },
      { headerName: 'Quantity Interval', field: 'quantity_interval', resizable: true, filter: true },
      { headerName: 'Delivery Date', field: 'delivery_date', resizable: true, filter: true, valueFormatter: (params: any) => {
        const value = params.value? params.value.split("T")[0].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"): params.value;
        if(value) {
          return this.dp.transform(value, 'dd-MM-yyyy', 'es-ES');
        }
        return params.value;
      } },
      { headerName: 'Delivery time', field: 'delivery_time', resizable: true, filter: true },
      { headerName: 'UNSPSC-20.0601', field: 'unspsc', resizable: true, filter: true },
      { headerName: 'Category 1', field: 'category1', resizable: true, filter: true },
      { headerName: 'Mime Info', field: 'mime_info', resizable: true, filter: true },
      { headerName: 'Datasheet', field: 'datasheet', resizable: true, filter: true },
      { headerName: 'Keyboard', field: 'keyword', resizable: true, filter: true },
      { headerName: 'Intrastat Net Weight', field: 'intrastat_net_weight', resizable: true, filter: true },
      { headerName: 'Intrastat Gross Weight', field: 'intrastat_gross_weight', resizable: true, filter: true },
      { headerName: 'Intrastat Weight Unit', field: 'intrastat_weight_unit', resizable: true, filter: true },
      { headerName: 'Packaging Width', field: 'packaging_width', resizable: true, filter: true },
      { headerName: 'Packaging Height', field: 'packaging_height', resizable: true, filter: true },
      { headerName: 'Packaging Depth', field: 'packaging_depth', resizable: true, filter: true },
      { headerName: 'Incoterms', field: 'inco_term', resizable: true, filter: true },
      { headerName: 'Incoterms city', field: 'inco_terms_city', resizable: true, filter: true },
      { headerName: 'ECCN', field: 'eccn', resizable: true, filter: true },
      { headerName: 'EXPORT_LIST_NUMBER', field: 'export_list_number', resizable: true, filter: true },
      { headerName: 'HSN SAC CODE', field: 'hsn_sac_code', resizable: true, filter: true },
      { headerName: 'YA_PARTNER', field: 'ya_partner', resizable: true, filter: true },
      { headerName: 'ESN Number', field: 'esn_number', resizable: true, filter: true },
      { headerName: 'TAX Code', field: 'tax_code', resizable: true, filter: true },
      { headerName: 'Special Treatment', field: 'special_treatment', resizable: true, filter: true },
      { headerName: 'Flags', field: 'flags', resizable: true, filter: true },
      { headerName: 'Is Core', field: 'is_core', resizable: true, filter: true },
      { headerName: 'Multi Supplier ID', field: 'multi_supplier_id', resizable: true, filter: true },
      { headerName: 'Multisupplier Name', field: 'multi_supplier_name', resizable: true, filter: true },
      { headerName: 'Supplier Location', field: 'supplier_location', resizable: true, filter: true },
      { headerName: 'Rate Contract Available', field: 'rate_contract_available', resizable: true, filter: true },
      { headerName: 'Rate Contract Validity', field: 'rate_contract_validity', resizable: true, filter: true, valueFormatter: (params: any) => {
        const value = params.value? params.value.split("T")[0].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"): params.value;
        if(value) {
          return this.dp.transform(value, 'dd-MM-yyyy', 'es-ES');
        }
        return params.value;
      } },
      { headerName: 'No_CU_per_OU', field: 'no_cu_per_ou', resizable: true, filter: true },
      { headerName: 'Content Unit', field: 'content_unit', resizable: true, filter: true },
      { headerName: 'Lower Bound2', field: 'lower_bound2', resizable: true, filter: true },
      { headerName: 'Price amount2', field: 'price_amount2', resizable: true, filter: true },
      { headerName: 'Quantity max', field: 'quantity_max', resizable: true, filter: true },
      { headerName: 'ECLASS-10.1', field: 'eclass_10_1', resizable: true, filter: true },
      { headerName: 'Category2', field: 'category2', resizable: true, filter: true },
      { headerName: 'Category3', field: 'category3', resizable: true, filter: true },
      { headerName: 'Category4', field: 'category4', resizable: true, filter: true },
      { headerName: 'Detailed', field: 'detailed', resizable: true, filter: true },
      { headerName: 'EAN', field: 'ean', resizable: true, filter: true },
      { headerName: 'FName1', field: 'fname1', resizable: true, filter: true },
      { headerName: 'FValue1', field: 'fvalue1', resizable: true, filter: true },
      { headerName: 'FUnit1', field: 'funit1', resizable: true, filter: true },
      { headerName: 'Reference Sparepart', field: 'reference_sparepart', resizable: true, filter: true },
      { headerName: 'Reference Similar', field: 'reference_similar', resizable: true, filter: true },
      { headerName: 'Reference Follow Up', field: 'reference_follow_up', resizable: true, filter: true },
      { headerName: 'Reference Mandatory', field: 'reference_mandatory', resizable: true, filter: true },
      { headerName: 'Reference Select', field: 'reference_select', resizable: true, filter: true },
      { headerName: 'Reference Accessories', field: 'reference_accessories', resizable: true, filter: true },
      { headerName: 'Reference consists Of', field: 'reference_consists_of', resizable: true, filter: true },
      { headerName: 'Intrastat Code', field: 'intrastat_code', resizable: true, filter: true },
      { headerName: 'Intrastat Origin Country', field: 'intrastat_origin_country', resizable: true, filter: true },

      { headerName: 'Account Assignment Category', field: 'acc_assignment_category', resizable: true, filter: true },
      { headerName: 'Account Assignment Value', field: 'acc_assignment_value', resizable: true, filter: true },
      { headerName: 'GL Account', field: 'gl_account', resizable: true, filter: true },
      { headerName: 'Sales Order No', field: 'sales_order_no', resizable: true, filter: true },

    ];
    return coldefs;
  }

  public getRcData(): Observable<IAPIResponse<Array<IBuyerRC>>> {
    return this.http.get<IAPIResponse<Array<IBuyerRC>>>(`${API_URL.BUYER.RCGET}`);
  }

  public addRcData(body: IBuyerRC[]): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<IAPIResponse<Array<any>>>(`${API_URL.UPLOAD_RC}`, body);
  }

  public deleteRcData(id: any[]): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<IAPIResponse<Array<any>>>(`${API_URL.DELETE_RC}id=${this._encryptionService.encryptPayload(encodeURIComponent(id.toString()))}`, {});
  }

  public getPPCSearchResults(filterParams: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.get<IAPIResponse<Array<any>>>(`${API_URL.BUYER.PPC_RESULT}IP_MATERIAL_NUMBER=${this._encryptionService.encryptPayload(encodeURIComponent(filterParams.IP_MATERIAL_NUMBER))}&IP_VENDOR_NUMBER=${this._encryptionService.encryptPayload(encodeURIComponent(filterParams.IP_VENDOR_NUMBER))}`);
  }

  public validatePriceWithPPC(selectedPPCRecord: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<IAPIResponse<Array<any>>>(`${API_URL.BUYER.VALIDATE_PRICE_PPC}`, selectedPPCRecord);
  }

  public getPPCResultsColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [

      { headerName: 'ID', field: 'ID', resizable: true, filter: true },
      { headerName: 'Info Record', field: 'Info_Record', resizable: true, filter: true },
      { headerName: 'Vendor Material#', field: 'Vendor_Material_Number', resizable: true, filter: true },
      { headerName: 'Coountry of Origin', field: 'Country_of_Origin', resizable: true, filter: true },
      { headerName: 'Available Deliverable until', field: 'Available_Deliverable_Until', resizable: true, filter: true },
      { headerName: 'Vendor Account Number', field: 'Vendor_Account_Number', resizable: true, filter: true },
      { headerName: 'Material Number', field: 'Material_Number', resizable: true, filter: true },
      { headerName: 'Planned Delivery Time', field: 'Planned_Delivery_Time', resizable: true, filter: true },
      { headerName: 'Standard Purchase Order Quantity', field: 'Standard_Purchase_Order_Quantity', resizable: true, filter: true },
      { headerName: 'Minimum Purchase Order Quantity', field: 'Minimum_Purchase_Order_Quantity', resizable: true, filter: true },
      { headerName: 'Net Price In Purchasing Info Record', field: 'Net_Price_in_Purchasing_Info_Record', resizable: true, filter: true }
    ];
    return coldefs;
  }

  public openPRDetailsModal(purchaseRequest: IPurchaseRequest): void {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: `Purchase Request Details : ${purchaseRequest.pr_number}`,
        purchaseRequest
      },
      backdrop: 'static',
      class: 'modal-xl'
    };
    const bsModalRef: BsModalRef = this._modalService.show(PrDetailsComponent, initialState);
  }

  public getPurchaseRequestDetail(prId: string): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    const id = parseInt(prId)
    return this.http.get<IAPIResponse<Array<IPurchaseRequest>>>(`${API_URL.GET_ALL_PR}?prId=${id}`,);
  }
}
